<style src="./NewStock.scss" lang="scss" scoped></style>
<template>
  <section class="new-stock">
    <form-file-input @close="closePanel" />
  </section>
</template>

<script>
import FormFileInput from './form-file-input/FormFileInput'

export default {
  name: 'NewStock',
  components: {
    FormFileInput
  },
  methods: {
    closePanel () {
      this.$parent.$emit('close', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/stock/components/new-stock/NewStock.vue